module.exports = __webpack_public_path__ + "static/img/t4@2x.da1b6c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/picture/t4@2x.jpg
// module id = iXVQ
// module chunks = 1